import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

import DividerWithTitle from '../../components/DividerWithTitle';

import coverImage from '../../assets/imgs/img_expetrts.png';
import {
  FeaturesContainer,
  FeaturesSection,
  FeatureSubtitle,
} from './components/FeatureComponents';
import { useTranslation } from 'react-i18next';

export default function LandingExpertTeam() {
  const { t } = useTranslation();

  return (
    <FeaturesSection>
      <DividerWithTitle
        title={t('informationServices.expertTeam.dividerTitle')}
      />
      <FeaturesContainer>
        <ImageContainer></ImageContainer>
        <Box
          display='flex'
          flexDirection='column'
          rowGap={4}
          sx={{
            width: { xs: '100%', md: '400px' },
            alignItems: { xs: 'center', md: 'flex-start' },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <FeatureSubtitle>
            {t('informationServices.expertTeam.subtitle')}
          </FeatureSubtitle>
          <Typography
            fontWeight={300}
            color='text.primary'
            sx={{
              fontSize: { xs: '14px', md: '14px' },
              maxWidth: { xs: '100%', md: '800px' },
            }}
          >
            {t('informationServices.expertTeam.description')}
          </Typography>
        </Box>
      </FeaturesContainer>
    </FeaturesSection>
  );
}

const ImageContainer = styled(Box)(({ theme }) => ({
  background: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '390px',
  width: '620px',
  marginRight: '53px',
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '250px',
    marginRight: '0',
    order: -1,
  },
  [theme.breakpoints.down('sm')]: {
    height: '200px',
  },
}));
